// removed by extract-text-webpack-plugin
module.exports = {"roles":"_30v59nja_tGdPqHhMMcGnQ","list":"_2GjbggA2BA_-0BHgcoQlho","overlayContainer":"_3ENzPOg1KG7v7hkA9C02jR","inputContainer":"yInFeSP5Exv4MibfiDgpQ","inputLabel":"_3rt-FRAMj3MIQ7S2N82QmL","addOverlayContainer":"cutu8T0KK9JMGmq9S138n","addContainer":"_3qaJ1iBx_w-82pyWUHoTf8","addBtn":"_3mZ1ILO3gPFuwYXqlGf0I-","addHeader":"_33JYreRIK4F_V253MBTgQA","addHeaderLabel":"_1vnKMFwwZpr9blRZjpHRcu","createBtn":"_3oT3GF2eSohGYWsRM4nmKv"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Roles/Sidebar/style/Roles.pcss
// module id = 479
// module chunks = 0